.wrapper {
  display: grid;
  justify-items: center;
  gap: var(--space-3);
  padding: var(--space-16) var(--space-6);
  text-align: center;
  animation: ela-fade-in var(--duration-normal) var(--ease-out);
}

.compact {
  padding: var(--space-8) var(--space-4);
}

.iconWrap {
  display: grid;
  place-items: center;
  width: 52px;
  height: 52px;
  border-radius: var(--radius-lg);
  background: var(--bg-inset);
  border: 1px solid var(--border-subtle);
  color: var(--text-tertiary);
  margin-bottom: var(--space-1);
}

.neutral {
  color: var(--text-tertiary);
}

.danger {
  color: var(--danger);
  background: var(--danger-subtle);
  border-color: var(--danger);
}

.warning {
  color: var(--warning);
  background: var(--warning-subtle);
  border-color: var(--warning);
}

.accent {
  color: var(--accent);
  background: var(--accent-subtle);
  border-color: var(--accent-border);
}

.title {
  font-size: var(--text-md);
  font-weight: var(--weight-semibold);
}

.message {
  max-width: 46ch;
  font-size: var(--text-base);
  color: var(--text-secondary);
  line-height: var(--leading-relaxed);
}

.action {
  margin-top: var(--space-3);
}
